export default __webpack_public_path__ + "static/media/close-session.min.3ef43794.txt";